import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from "@material-ui/pickers";
import MaterialTable, { MTableToolbar } from 'material-table';
import { Checkbox, FormControlLabel, Paper } from '@material-ui/core'; 
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CartIcon from '@material-ui/icons/ShoppingCart';
import SyncIcon from '@material-ui/icons/Sync';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';

import Awb from '../../../models/Awb';
import AwbPart from '../../../models/AwbPart';

import Moment from 'moment';

import addAWBModalStyles from './addAWBModal.module.css';
import commonStyles from '../../common/common.module.css';

import tableIcons from '../../../utils/editTableIcons'
import AirlineType from '../../../models/AirlineType';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

const iconFontSize = 22;
interface NotDeliveredPart {
  not_delivered_pieces: number,
  not_delivered_weight: number
}
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      fontSize: iconFontSize,
      color: 'rgba(0, 0, 0, 0.87)',
      '&:hover': {
        cursor: 'pointer',
      }
    },
    dialogPaper: {
      width: '100%',
    },
    wrapper: {
      paddingTop: '25px',
      marginTop: '10px',
      },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    marginTop1px: {
      marginTop: '1px'
    },
    checkbox: {
      padding: '0',
      '& svg':{
        fontSize: '20px'
      }
    },
    marginBottomMinus7px: {
      marginBottom: '-7px'
    },
    selectStatusStyle: {
      width: '170px',
      fontSize: '0.8125rem'
    },
    selectFlightStyle: {
      width: '70px',
      fontSize: '0.8125rem',
      textAlign: 'right'
    },
    buttonsWrapper: {
      margin: '0 2% 20px 2.5%'
    },
    close: {
      marginTop: '10px'
    },
    actionStyle: {
      '& .MuiTableSortLabel-root-314': {
        '&:hover': {
          cursor: 'text',
          color: 'white'
        }
      }
    },
    table: {
      border: '1px solid rgba(0, 0, 0, 0.1)'
    },
    input: {
      '& [disabled] ': {
        color: 'var(--primaryblue)',
        textAlign: 'center'		
      }
    },
    inputTextFieldTable: {
      fontSize: '0.8125rem',
      width: '85px',
      '& [disabled] ': {
        color: 'var(--primaryblue)',
      }
    },
    toolbar: {
      '& > div > div:nth-child(2)': {
        display: 'none',
      },
      '& > div > div:first-child': {
        marginLeft: 'auto',
      }
    }
  });

interface AddAWBModalProps {
  classes: any;
  errorMsg: any;
  awb: Awb;
  refresh: boolean;
  handleChange: Function;
  onValidationPcs: any;
  onValidationWgt: any;
  handleClose: (modalType: string) => void;
  handleSync?: Function;
  modalOpen: boolean;
  availableAwbPartStatusesForProcess: string[];
  setState: Function;
  enableCartIcon: Function;
  handleSave: Function;
  errorClose: string;
  awbActionOfUpdateButton: 'add' | 'update';
  manualEntry?: boolean;
  airlines: AirlineType[];
  addPart: Function;
  deletePart: (partId: number) => void;
  handleOpenPoD?: (code: string, number: string, version: number) => void;
  awbInfo?: boolean;
  partErrorMsg: string;
  notDelivered: NotDeliveredPart;
  userRole: string;
  managerAccess: boolean;
  disableUpdate?: boolean;
};

const addAWBModal = ( props: AddAWBModalProps ) => {

  const isTrueFlag = (value: any): boolean => value === true || value === 1 || value === '1' || value === 'true';
  const hasOrderLink = (part: any): boolean => {
    const hasOrderInfo = !!(part?.order_info && (part.order_info.order_number || part.order_info.delivered_date));
    return hasOrderInfo || isTrueFlag(part?.in_order) || !!part?.id_order;
  };
  const hasDeliveredOrderInfo = (part: any): boolean => !!(part?.order_info && part.order_info.delivered_date);
  const isDeliveredPart = (part: any): boolean => hasDeliveredOrderInfo(part) || (isTrueFlag(part?.delivered) && hasOrderLink(part));
  const isInExistingOrder = (part: any): boolean => isTrueFlag(part?.in_order);

  const { classes } = props;
  const airlineOptions = props.airlines.map((airline: AirlineType) => {
    return (<option value={ airline.iata_code } key={ airline.id }>{ airline.iata_code }</option>);
  });
  const allowedAwbUpdateAction: boolean = props.awb.allowed_ops.update_awb;
  const disabledOriginAndDestination: boolean = !props.awb.manually_entered || !allowedAwbUpdateAction;
  const errorPart: JSX.Element = (
    props.errorClose != '' ? <div className={ addAWBModalStyles.errorClose }>{ props.errorClose }</div> :
    <span className={ addAWBModalStyles.errorPart }>
      <p>{ props.errorMsg.add }</p> 
      <p>{ props.errorMsg.pieces }</p> 
      <p>{ props.errorMsg.weight }</p> 
    </span>
    );
    const partError: JSX.Element = (
      props.partErrorMsg  ?
      <span className={ addAWBModalStyles.errorPart }>
        <p>{ props.partErrorMsg }</p> 
      </span> : <div></div> 
      );
  const tableTitle: JSX.Element = allowedAwbUpdateAction ? <span className={ addAWBModalStyles.tableTitle }>Add new part</span>	: 
    <span className={ addAWBModalStyles.tableTitleError }></span>

  const classNameValPcs: string = props.errorMsg.pieces ? `${ addAWBModalStyles.validation } ${ addAWBModalStyles.textField }` : `${ addAWBModalStyles.textField }`;
  const classNameValWeight: string = props.errorMsg.weight ? `${ addAWBModalStyles.validation } ${ addAWBModalStyles.textField }` : `${ addAWBModalStyles.textField }`;
  const canAddToOrder: boolean = props.awb.allowed_ops.add_awb_cart !== undefined
    ? !!props.awb.allowed_ops.add_awb_cart
    : !!props.awb.allowed_ops.add_part;
  const hasSelectedPart: boolean = (props.awb.import_parts || []).some((part: any) => isTrueFlag(part.added) || isTrueFlag(part.cart));
  const hasRequiredAwbFields: boolean = !!(props.awb.destination && props.awb.origin && props.awb.pieces && props.awb.weight && props.awb.import_parts.length > 0);
  const disableUpdateOptions: boolean = props.awbActionOfUpdateButton === 'update'
    ? !props.awb.allowed_ops.update_awb
    : !canAddToOrder;
  const disableUpdate: boolean = props.disableUpdate || (props.awbActionOfUpdateButton === 'update'
    ? (!hasRequiredAwbFields || disableUpdateOptions)
    : (!canAddToOrder || props.awb.import_parts.length === 0 || !hasSelectedPart));

  const title = (
    <div>
      <div className={ addAWBModalStyles.headerTitleContainer} >
        <span className={ addAWBModalStyles.headerTitle }>Verify Shipment Details</span>
        <IconButton aria-label="Close" className={ classes.close } onClick={ () => props.handleClose('import') }>
              <CloseIcon color='primary' />
            </IconButton> 
      </div> 
      <div className={ addAWBModalStyles.awbDetails }>
        <div className={ addAWBModalStyles.awbWrapper }>
          <span className={ addAWBModalStyles.iconText }>
            { !props.awb.edited && props.handleSync && props.refresh && allowedAwbUpdateAction
              ? <Typography><SyncIcon className={ [ classes.materialIcon, classes.marginBottomMinus7px ].join(' ') } onClick={ ()=> props.handleSync!(props.awb.code, props.awb.number) } />Auto updated</Typography>
              : !props.manualEntry ?
                <Typography><SyncIcon className={ [ classes.disabledIcon, classes.marginBottomMinus7px ].join(' ') } />{ props.awb.edited? 'Manually updated': 'Auto updated' }</Typography>
              : null
            }
          </span>
          <span className={ addAWBModalStyles.text }>{ props.awb.code }-{ props.awb.number }</span>
        </div>
        <div className={ `${ addAWBModalStyles.awbDetailsWrapper } ${props.manualEntry ? '' : addAWBModalStyles.awbDetailsWrapperManual }` }>
          {
            props.manualEntry ?
            <div className={ `${ addAWBModalStyles.pcsWgh} ${ addAWBModalStyles.pcsWghWrapper }` }>Pcs: {props.awb.pieces}</div>
            :
            <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
              <p className={ addAWBModalStyles.pcsWgh }>Pcs:</p>
              <TextField
                id="pieces"
                // label="Pieces"
                className={ classNameValPcs }
                value={ props.awb.pieces }
                onChange={ () => props.handleChange('pieces', event) }
                onBlur={ props.onValidationPcs } 
                error={ !props.awb.pieces || isNaN(+props.awb.pieces) || +props.awb.pieces<=0  }
                helperText={ (!props.awb.pieces || isNaN(+props.awb.pieces) || +props.awb.pieces<=0)  ? 'Add AWB Pcs ' : '' }
                disabled={ !allowedAwbUpdateAction }
                InputProps={{ className: classes.input, disableUnderline: !allowedAwbUpdateAction }}
              />
            </div>
          }
          {
            props.manualEntry ?
              <div className={ `${ addAWBModalStyles.pcsWgh } ${ addAWBModalStyles.pcsWghWrapper }` }>Wgt: {props.awb.weight? parseFloat(props.awb.weight).toFixed(1) : '0.0'}K</div>
            :
            <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
              <p className={ addAWBModalStyles.pcsWgh }>Wgt:</p>
              <TextField
                id="weight"
                // label="Weight"
                className={ classNameValWeight }
                value={ props.awb.weight }
                onChange={ () => props.handleChange('weight', event) }
                onBlur={ props.onValidationWgt }
                error={ !props.awb.weight || isNaN(+props.awb.weight) || +props.awb.weight<=0 }
                helperText={ (!props.awb.weight || isNaN(+props.awb.weight) || +props.awb.weight<=0) ? 'Add AWB Wgt ' : '' }
                disabled={ !allowedAwbUpdateAction }
                InputProps={{ className: classes.input, disableUnderline: !allowedAwbUpdateAction }}
              />
            </div>
          }
          <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
            <p className={ addAWBModalStyles.pcsWgh }>Org:</p>
            <TextField
              id="origin"
              autoFocus={props.manualEntry}
              className={ addAWBModalStyles.textField }
              value={ props.awb.origin }
              onChange={ () => props.handleChange('origin', event) }
              error={ !props.awb.origin }
              helperText={ !props.awb.origin ? 'Add Origin': '' }
              disabled={!props.managerAccess ? disabledOriginAndDestination : false}
              InputProps={{ className: classes.input, disableUnderline: disabledOriginAndDestination }}
            />
          </div>
          <div className={ `${ addAWBModalStyles.hInputLabelWrapper } ${ addAWBModalStyles.awbDetailsInner }` }>           
            <p className={ addAWBModalStyles.pcsWgh }>Dest:</p>
            <TextField
              id="destination"
              className={ addAWBModalStyles.textField }
              value={ props.awb.destination }
              onChange={ () => props.handleChange('destination', event) }
              error={ !props.awb.destination }
              helperText={ !props.awb.destination ? 'Add Dest': '' }
              disabled={!props.managerAccess ? disabledOriginAndDestination : false}
              InputProps={{ className: classes.input, disableUnderline: disabledOriginAndDestination }}
            />
          </div>
        </div>
      </div>
      <hr className={ addAWBModalStyles.hrStyle } />
      { errorPart }
    </div> 
  );
    
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleClose('import') }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'lg' }
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="form-dialog-title">{ title }</DialogTitle>
      <DialogContent className={ classes.actionStyle }>
        <div className={ `${ commonStyles.wrapper } ${ classes.wrapper }` }>
          <h3 className={ `${ commonStyles.header }` }> Shipment Details </h3>
          <div>
           { props.notDelivered.not_delivered_pieces > 0  ?` ${props.notDelivered.not_delivered_pieces} pieces not delivered` : ''}
          </div>
          <MaterialTable 

            components={{
              Container: props => <Paper {...props} elevation={0} className={ `${ commonStyles.paperTable } ${ commonStyles.tablepaper } ${ commonStyles.SelectTable }` }/>,
              Toolbar: (props) => (
                <div className={ classes.toolbar }>
                  <MTableToolbar {...props} />
                </div>
              )
            }}

            icons={ tableIcons }

            title = { tableTitle }

            columns = {[
              { title: 'Flight', field: 'flight',
              render: (rowData: any) => {
                const flightDate: string = rowData.flight_date ? Moment(rowData.flight_date).format('DD-MMM').toUpperCase() : '';
                const flight: string = rowData.flight ? `${rowData.flight_no} /${flightDate}` : '';
                return <span className={[classes.selectFlightStyle, addAWBModalStyles.flightCol].join(" ")}>{ flight }</span>;
              },
                editComponent: (editProps: any) => {

                  return <div>
                        { props.userRole !== 'forwarder' ? 
                          <Select
                            native
                            id="airlineValue"
                            name="airlineValue"
                            onChange={ e => editProps.onChange(e.target.value) } 
                            className={classes.selectFlightStyle}
                            value={ editProps.rowData.flight }
                          >
                            <option value='' />
                            { airlineOptions }
                          </Select> : 
                          <TextField
                            value={ editProps.rowData.flight }
                            placeholder="Airline Code"
                            InputProps={{ className: classes.inputTextFieldTable }}
                            className={ addAWBModalStyles.flight_no }
                            onChange={ e => editProps.onChange(e.target.value) } 
                          />
                        }
                        
                  </div>
                },
                cellStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'center', width: '15%' }, 
                headerStyle: { paddingRight: 0, paddingLeft: '22px', textAlign: 'center', width: '15%' }
              },
              { title: '', field: 'flight_number',
              render: () => (
                null
              ),
              editComponent: (props: any) => {
                return <TextField
                          autoFocus={ true }
                          value={ props.value }
                          placeholder="Flight No"
                          InputProps={{ className: classes.input }}
                          className={ addAWBModalStyles.flight_no }
                          onChange={ e => props.onChange(e.target.value) } 
                        />
               },
                cellStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'left', width: '10%' },
                headerStyle: { maxWidth: 0, paddingRight: 0, paddingLeft: 0, textAlign: 'left', width: '5px' }
              },
              { title: '', field: 'flight_date',
                render: (rowData: any) => {

                  return null;
                },
                editComponent: (props: any) => {
                  return <KeyboardDatePicker
                            value={ props.value ? props.value : null }
                            format={ 'DD-MMM-YY' }
                            placeholder="Flight Date"
                            InputProps={{ className: classes.inputTextFieldTable }}
                            className={ classes.datePicker }
                            onChange={ (e: any) => {
                              const newDate: string = Moment(e._d).format('YYYYMMDD');
                              props.onChange(newDate);
                            }}
                            autoOk
                          />;
                },
                cellStyle: { paddingLeft: 0, paddingRight: '10px' },
                headerStyle: { paddingRight: 0, paddingLeft: 0 }
              },
              { title: 'Arrv Date', field: 'arrival_date',
                render: (rowData: any) => {

                  const arrivalDate: string = rowData.arrival_date ?  Moment(rowData.arrival_date).format('DD-MMM-YYYY').toUpperCase(): '';
                  return <span>{ arrivalDate }</span>;
                },
                editComponent: (props: any) => {

                  return <KeyboardDatePicker
                            autoOk
                            value={ props.value ? props.value : null }
                            format={ 'DD-MMM-YY' }
                            placeholder="Arrv Date"
                            InputProps={{ className: classes.inputTextFieldTable }}
                            onChange={ (e: any) => {
                              const newDate = Moment(e._d).format('YYYYMMDD');
                              props.onChange(newDate);
                            }}
                          />;
                },cellStyle: {  paddingRight: '10px' },
              },
                { title: 'Pcs', field: 'pieces', cellStyle: { width: '6%' }, headerStyle: { width: '6%' },
                render: (rowData: AwbPart) => {
                  const notDelivered: string = `${rowData.not_delivered_pieces}/${rowData.pieces}`;
                  return (<span >{ rowData.not_delivered_pieces > 0 ? notDelivered : rowData.pieces}</span>)
              }},
              { title: 'Wgt', field: 'weight',
                render: (rowData: AwbPart) => {
                  const weight: number = +(rowData.weight);
                  return (<span >{weight.toFixed(1)}K</span>)
              }},
              { title: 'Status', field: 'status',
              render: (rowData: AwbPart) => {

                const orderInfo = rowData.order_info;
                if (orderInfo?.delivered_date) {
                  const delivery = "Part Delivered: " + Moment(orderInfo.delivered_date).format("DDMMMYY") + " " + orderInfo.delivered_time + " " + `order # ${orderInfo.order_number}`;
                  return (
                    <span>
                      <span>{delivery ? delivery : rowData.status}</span>
                      <span className={ addAWBModalStyles.poD } onClick={ () => props.handleOpenPoD ? props.handleOpenPoD(props.awb.code , props.awb.number, props.awb.version) : null }>PoD</span>
                          
                    </span>
                      
                  )
                }

                if (isDeliveredPart(rowData)) {
                  return <span>Part Delivered</span>;
                }

                return (
                  <span>{ rowData.status }</span>
                )
               
              },
                editComponent: (editComponentProps: any) => {
                  return (<Select native
                    value={editComponentProps.value || ''}
                    onChange={ e => {
                      editComponentProps.onChange(e.target.value);
                    } }
                    className={classes.selectStatusStyle}>
                    <option key="" value=""></option>
                    {props.availableAwbPartStatusesForProcess.map((status: string) => <option value={status} key={status}>{status}</option>)}
                  </Select>);
              },
                cellStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'left', width: '35%' },
                headerStyle: { maxWidth: 0, paddingRight: 0, paddingLeft: 0, textAlign: 'left', width: '5px' }
              }
            ]}

            data = { props.awb.import_parts }
          
            editable = { allowedAwbUpdateAction  ? {
              onRowAdd: (newData: any) => 
                new Promise<void>((resolve, reject) => {

                  if (!newData.flight_number || newData.pieces === '' || newData.flight === '' || newData.weight === '' || newData.flight_date === ''|| !newData.pieces || !newData.weight || !newData.flight_date || (+newData.pieces<=0) || +newData.weight<=0 || isNaN(newData.pieces) || isNaN(newData.weight) ) {

                    props.setState({ errorMsg: { ...props.errorMsg, add: 'The field is empty or in incorrect format!' } });
                    reject();

                    let cancel: HTMLSpanElement | null = document.querySelector("span[title='Cancel']");

                    if (cancel) {
                      cancel.addEventListener("click", () => {
                        props.setState({ errorMsg: { ...props.errorMsg, add: '' } } );
                      });
                    }

                    return;
                  } else {

                    props.setState({ errorMsg: { ...props.errorMsg, add: '' } } );
                    setTimeout(() => {
                      {
                        const awb: Awb = { ...props.awb }; 
                        newData.flight_no = newData.flight + newData.flight_number;
                        // newData.flight_number = newData.number;
                        const parts: AwbPart[] = [...props.awb.import_parts]; 
                        newData.flight_no = newData.flight + newData.flight_number;
                        parts.push(newData);
                        awb.import_parts = parts;

                        props.setState({ awb, refresh: false }, () => resolve()); 
                        props.onValidationPcs();
                        props.onValidationWgt();
                      }
                      resolve();
                    }, 1000);
                  }
              }),
              onRowUpdate: (newData:any, oldData:any) =>
                new Promise<void>((resolve, reject) => {

                  if (!newData.flight_number || newData.flight === '' || newData.pieces === '' || newData.weight === '' || newData.flight_date === '' || 
                    (+newData.pieces<=0) || +newData.weight<=0 || isNaN(newData.pieces) || isNaN(newData.weight)) {

                    props.setState({ errorMsg: { ...props.errorMsg, add: 'The field is empty or in incorrect format!' } });
                    reject();

                    let cancel: HTMLSpanElement | null = document.querySelector("span[title='Cancel']");

                    if (cancel) {
                      cancel.addEventListener("click", () => {
                        props.setState({ errorMsg: { ...props.errorMsg, add: '' } } );
                      });
                    }

                    return;
                  } else {
                    props.setState({ errorMsg: { ...props.errorMsg, add: '' } });

                    setTimeout(() => {
                      {
                        const awb: Awb = { ...props.awb };
                        newData.flight_no = newData.flight + newData.flight_number;
                        const parts: AwbPart[] = [...props.awb.import_parts]; 
                        const index: number = parts.indexOf(oldData);

                        parts[index] = newData; 
                        awb.import_parts = parts;
                        props.setState({ awb, refresh: false }, () => resolve()); 
                        props.onValidationPcs();
                        props.onValidationWgt();
                      }
                      resolve();
                    }, 1000);
                  }
              }),
              onRowDelete: (oldData: any) =>
                new Promise<void>((resolve, reject) => {
          
                  setTimeout(() => {
                    {
                      const awb: Awb = { ...props.awb }; 
                      const parts: AwbPart[] = [...props.awb.import_parts]; 
                      const index: number = parts.indexOf(oldData);
                      parts.splice(index, 1);
                      awb.import_parts = parts;
                    

                      props.setState({ awb, refresh: false }, () => resolve());
                      props.onValidationPcs();
                      props.onValidationWgt();
                    }
                    resolve();
                  }, 1000);
              }),
            }: undefined }
          

            actions = {[
              (rowData: any) => ({
                icon: () => <FormControlLabel
                value=""
                control={
                  <Checkbox
                    name=''
                    icon={ <CheckBoxOutlineBlankIcon color="primary"/> }
                    checkedIcon={ <Checkbox color="primary" checked={ isTrueFlag(rowData.added) || isTrueFlag(rowData.cart) || isInExistingOrder(rowData) } disabled={ isInExistingOrder(rowData) || isDeliveredPart(rowData) || !!props.awbInfo }/> }
                    classes={{
                      root: classes.checkbox,
                    }}
                    checked={ isTrueFlag(rowData.added) || isTrueFlag(rowData.cart) || isInExistingOrder(rowData) }
                    disabled={ isInExistingOrder(rowData) || isDeliveredPart(rowData) || !!props.awbInfo }
                  />
                }
                label={''}
                className={`${ commonStyles.textCenter } ${ classes.completeLabel }`}
              />,
                tooltip: 'Add to cart',
                onClick: props.enableCartIcon(rowData) && !isDeliveredPart(rowData) && !props.awbInfo ? (event, rowData: any) =>  props.addPart(rowData) : () => {},
                disableUpdate: props.awbInfo
              })
            ]}

            options = {{
              sorting: false,
              search: false,
              paging: false,
              actionsColumnIndex: -1,
              rowStyle: (rowData: AwbPart) => ({
                color: isInExistingOrder(rowData) || isDeliveredPart(rowData) ? '#fff' : '#000',
              }),
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              }
            }}
          />
        </div>
       { partError }
      </DialogContent>
      <DialogActions className={ classes.buttonsWrapper } >
        <Button onClick={ () => { props.handleSave(props.awb, {edit: true, metadata: false})} } color="primary" disabled={ disableUpdate } variant="contained">{ props.awbInfo ? "Update Changes" : "Add Selected Entries To Order" }</Button>    
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(addAWBModal);